import request from './index'

// 获取分组列表
export function getList() {
  return request({
    url: '/user-group',
    method: 'get'
  })
}

// 新增分组
export function save(data) {
  return request({
    url: '/user-group/save',
    method: 'post',
    data
  })
}

// 获取分组详情（含成员列表）
export function getDetail(id) {
  return request({
    url: '/user-group/' + id,
    method: 'get'
  })
}

// 更新分组
export function update(id, data) {
  return request({
    url: '/user-group/update/' + id,
    method: 'post',
    data
  })
}

// 删除分组
export function deleteGroup(id) {
  return request({
    url: '/user-group/delete/' + id,
    method: 'post'
  })
}

// 添加分组成员
export function addMember(data) {
  return request({
    url: '/user-group/add-member',
    method: 'post',
    data
  })
}

// 移除分组成员
export function removeMember(groupId, userId) {
  return request({
    url: '/user-group/' + groupId + '/member/' + userId,
    method: 'post'
  })
}
